exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#top-nav h1.privacy {\r\n    color: #fff;\r\n    font-size: 22px;\r\n    line-height: 48px;\r\n    margin: 3px;\r\n}\r\n.privacypolicy{background: #fff;}\r\n.privacy-content > h5{\r\n    padding: 10px 0px;\r\n    font-size: 16px;\r\n    color: #3c3c3c;\r\n    margin: 0px;\r\n}\r\n.privacy-content > ol{\r\n    padding: 10px 0 0 30px;\r\n    line-height: 22px;\r\n}\r\n.privacy-content > ol li{\r\n    padding: 4px 0px;\r\n}\r\n.privacy-content > ol li ul li{\r\n    padding: 4px 0px;\r\n    list-style-type: disc;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/privacy/privacy-policy/privacy-policy.component.css
// module id = 1078
// module chunks = 0